module.exports = __webpack_public_path__ + "img/ico-feature_3.b259736c.svg";